import { useSelector } from 'react-redux';
import { ACCOUNT_MODULES, PERMISSIONS } from '_constants';
import { AuthEntity } from '_entities';
import HasAccess from 'modules/AccessControl/hasAccess';

const { getAuthenticatedUser, getModularityPermissions } = AuthEntity.selectors;

// New UI 2026 gating, with two contexts:
// - Authenticated users get the new UI only when the account has the `new_ui_2026_06` module AND
//   the role has `use_new_ui_2026_06` (mirrors the advanced_search pattern in modules/VisitsListPage).
//   HasAccess merges account_modules into the permission set and requires every entry of the array.
// - Public / unauthenticated visitors have no role or account profile, so they are gated purely on
//   the `new_ui_2026_06` entry in `modularity_permissions`, which App.js fetches unconditionally on
//   mount. Otherwise everyone falls back to the old design.
const NEW_UI_PERMISSIONS = [ACCOUNT_MODULES.NEW_UI_2026_06, PERMISSIONS.USE_NEW_UI_2026_06];

const useNewUi = () => {
  const isAuthenticated = useSelector(getAuthenticatedUser);
  const modularityPermissions = useSelector(getModularityPermissions);
  const hasAuthenticatedNewUi = HasAccess(NEW_UI_PERMISSIONS);

  if (isAuthenticated) return hasAuthenticatedNewUi;
  return (modularityPermissions || []).includes(ACCOUNT_MODULES.NEW_UI_2026_06);
};

export default useNewUi;
